import { useTranslation } from '@lyearn/i18n';
import { RepeatOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Tooltip } from '@lyearn/ui';

function RecurringSessionIcon({ size = 16, className }: { size?: number; className?: string }) {
  const { t } = useTranslation('Events');

  return (
    <Tooltip title={t('Events:RecurringSession.RecurringSession')}>
      <RepeatOutline
        className={cn(
          `h-${size} w-${size} flex-shrink-0 text-icon-placeholder hover:text-icon-secondary`,
          className,
        )}
      />
    </Tooltip>
  );
}

export default RecurringSessionIcon;
